import { DiagramConnectorLabel } from "@/app/features/diagrams/components/shared/DiagramConnectorLabel";

export type WorkManagementFlowsProps = {
  /** Keeps this drawing's arrowhead ids apart from another's on the page. */
  markerPrefix: string;
};

export function WorkManagementFlows({
  markerPrefix,
}: WorkManagementFlowsProps) {
  return (
    <g data-layer="connectors" fill="none" strokeWidth="1.5">
      <path
        data-flow="start-a"
        d="M 200 100 L 338 100"
        stroke="currentColor"
        markerEnd={`url(#${markerPrefix}arrow-neutral)`}
      />
      <DiagramConnectorLabel x={270} y={82} text="Start" paddingX={12} />
      <path
        data-flow="handoff-a"
        d="M 340 126 L 202 126"
        stroke="var(--ga-diagram-repair)"
        strokeDasharray="4 3"
        markerEnd={`url(#${markerPrefix}arrow-repair)`}
      />
      <DiagramConnectorLabel x={270} y={148} text="Handoff" paddingX={12} />
      <path
        data-flow="start-b"
        d="M 200 228 L 338 228"
        stroke="currentColor"
        markerEnd={`url(#${markerPrefix}arrow-neutral)`}
      />
      <DiagramConnectorLabel x={270} y={208} text="Start" paddingX={12} />
      <path
        data-flow="hold-b"
        d="M 500 258 L 500 322"
        stroke="var(--ga-diagram-danger)"
        strokeDasharray="4 3"
        markerEnd={`url(#${markerPrefix}arrow-fallback)`}
      />
      <DiagramConnectorLabel x={500} y={290} text="Hold" paddingX={12} />
      <path
        data-flow="resume-b"
        d="M 400 324 L 400 260"
        stroke="var(--ga-diagram-repair)"
        markerEnd={`url(#${markerPrefix}arrow-repair)`}
      />
      <DiagramConnectorLabel x={400} y={292} text="Resume" paddingX={12} />
      <path
        data-flow="submit-a"
        d="M 560 100 L 698 100"
        stroke="currentColor"
        markerEnd={`url(#${markerPrefix}arrow-neutral)`}
      />
      <DiagramConnectorLabel x={630} y={82} text="Submit" paddingX={12} />
      <path
        data-flow="review-gate"
        d="M 760 140 L 760 208"
        stroke="currentColor"
        markerEnd={`url(#${markerPrefix}arrow-neutral)`}
      />
      <path
        data-flow="approve-a"
        d="M 760 250 L 760 336"
        stroke="var(--ga-diagram-success)"
        markerEnd={`url(#${markerPrefix}arrow-green)`}
      />
      <DiagramConnectorLabel x={760} y={294} text="Pass" paddingX={12} />
      <path
        data-flow="rework-a"
        d="M 722 230 L 630 230 L 630 122 L 562 122"
        stroke="var(--ga-diagram-danger)"
        strokeDasharray="4 3"
        markerEnd={`url(#${markerPrefix}arrow-fallback)`}
      />
      <DiagramConnectorLabel x={630} y={176} text="Rework" paddingX={12} />
      <path
        data-flow="cancel-c"
        d="M 120 380 L 120 428"
        stroke="var(--ga-diagram-danger)"
        strokeDasharray="4 3"
        markerEnd={`url(#${markerPrefix}arrow-fallback)`}
      />
      <DiagramConnectorLabel x={120} y={404} text="Cancel" paddingX={12} />
    </g>
  );
}
